import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { useParams, Link } from "react-router-dom";

const detailstitles = [
  "",
  "Maitre d’ouvrage",
  "Architecte",
  "Missions",
  "Montant HT",
  "Annee",
];

const references = [
  {
    id: 1,
    title: "Création d’une salle de scanner a vienne",
    image: "/images/reference1.jpg",
    details: [
      "Construction d’une extension pour héberger une salle de scanner et aménagement du service attenant. Intervention en site occupé",
      "Centre Hospitalier Lucien Hussel",
      "ID Pluriel Architectes",
      "Maitrise d’œuvre d’EXE, OPC",
      "500 000 €",
      "2022",
    ],
  },
  // {
  //   id: 2,
  //   title: "Création d’un service de réanimation",
  //   image: "/images/reference2.jpg",
  //   details: [
  //     "Restructuration d’un service de réanimation à Lons Le Saunier. Intervention en site occupé",
  //     "Centre hospitalier Jura Sud",
  //     "AVR Architectes",
  //     "OPC",
  //     "3 300 000 €",
  //     "2024",
  //   ],
  // },
  {
    id: 3,
    title: "Amenagement d’un salon de massage",
    image: "/images/reference3.jpg",
    details: [
      "Restauration d’une salle de sport et d’une cave voutée en salon de massage",
      "Massage concept",
      "Alexandra Roux",
      "Maitrise d’œuvre complète",
      "200 000 €",
      "2022",
    ],
  },
  {
    id: 4,
    title: "Extension maison médicale de Charvieu Chavagneux",
    image: "/images/reference4.jpg",
    details: [
      "Construction d’une extension de maison médicale sur 2 étages avec une partie sur pilotis ",
      "Hello pharmacie",
      "ID Pluriel Architectes",
      "Economie de la construction",
      "1 100 000 €",
      "2023",
    ],
  },
  {
    id: 5,
    title: "Construction de logements a Thoiry",
    image: "/images/reference5.jpg",
    details: [
      "Construction d’un bâtiment collectif de 12 logements à Thoiry",
      "ERILIA",
      "Scodellari Architecte",
      "Economie de la construction, Maitrise d’œuvre d’EXE, OPC",
      "1 850 000 €",
      "2024",
    ],
  },
  {
    id: 6,
    title: "Construction d’un bâtiment collectif et de maisons individuelles",
    image: "/images/reference6.jpg",
    details: [
      "Construction d’un bâtiment collectif de 10 logements et de 10 maisons individuelle à Saint andré le Gaz",
      "MAY’IMMO",
      "Atelier 3A Architectes",
      "Economie de la construction ",
      "2 400 000 €",
      "2023",
    ],
  },
  {
    id: 7,
    title: "Création d’un service de réanimation ",
    image: "/images/reference7.jpg",
    details: [
      "Restructuration d’un service de réanimation à Lons Le Saunier. Intervention en site occupé",
      "Centre hospitalier Jura Sud",
      "AVR Architectes",
      "OPC",
      "3 300 000 €",
      "2024",
    ],
  },
  {
    id: 8,
    title: "Rénovation des parkings résidence “Baratin” à Villeurbanne",
    image: "/images/reference8.jpg",
    details: [
      "Restructuration d’un bâtiment de parking de 2 niveaux de sous-sols afin d’ouvrir et sécuriser les parkings, anciennement insalubre et insécurisé.",
      "Alliade habitat",
      "Scodellari Architecte",
      "Economie de la construction, Maitrise d’œuvre d’exécution",
      "2 200 000 €",
      "2024",
    ],
  },
  {
    id: 9,
    title: "Réamenagment de la salle d’intervention ",
    image: "/images/reference9.png",
    details: [
      "Réaménagement de la salle d’intervention des HCL afin d’y installer un nouvel équipement. Intervention en site occupé",
      "Les hospices civils de Lyon",
      "ID Pluriel Architectes",
      "Economie de la construction, DET",
      "400 000 €",
      "2023",
    ],
  },
  {
    id: 10,
    title: "service dialyse de l'hôpital Saint Joseph",
    image: "/images/reference10.png",
    details: [
      "Rénovation du RDC de l'hôpital saint joseph pour le compte de AURA",
      "AURA Paris",
      "ID Pluriel Architecte",
      "Economie de la construction",
      "550 000 €",
      "2023",
    ],
  },
  {
    id: 11,
    title: "Rénovation DU SERVICE ENDOSCOPIE DU MEDIPOLE",
    image: "/images/reference11.jpg",
    details: [
      "Rénovation de l’accueil, de la salle de soins et de la salle SSPI du service endoscopie au Medipole de Villeurbanne. ",
      "Ramsay santé",
      "KOS Partners",
      "OPC, Maitrise d’œuvre d’exécution",
      "250 000 €",
      "2024",
    ],
  },
  {
    id: 12,
    title: "Rénovation du bloc opératoire à Arnas",
    image: "/images/reference12.jpg",
    details: [
      "Rénovation des salles SSPI et Réa-néonate de la clinique du Beaujolais à Arnas. Intervention en site occupé",
      "Ramsay santé ",
      "KOS Partners",
      "OPC, Maitrise d’œuvre d’exécution",
      "350 000 €",
      "2024",
    ],
  },
  {
    id: 13,
    title: "Construction du pôle sport et santé de Lacroix Lavale",
    image: "/images/reference13.jpeg",
    details: [
      "Construction d’une maison de santé à Marcy l’étoile avec 2 salles de rééducation",
      "Pôle sport et santé ",
      "Formidable Architecte",
      "Maitrise d’œuvre d’EXE, OPC ",
      "800 000 €",
      "2023",
    ],
  },
];

const ReferenceDetailPage = () => {
  const { id } = useParams();
  const reference = references.find((ref) => ref.id === parseInt(id));

  if (!reference) {
    return <div>Reference not found</div>;
  }

  const currentIndex = references.findIndex((ref) => ref.id === parseInt(id));
  const prevIndex = (currentIndex - 1 + references.length) % references.length;
  const nextIndex = (currentIndex + 1) % references.length;

  return (
    <div className="mx-auto px-4 md:px-12 lg:px-32 py-8 lg:py-32 relative">
      <div className="container">
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start gap-8">
          {/* Image */}
          <img
            src={reference.image}
            alt={reference.title}
            className="w-full lg:w-1/3 max-w-xs lg:max-w-md h-auto lg:h-96 object-cover shadow-xl rounded-lg"
          />

          {/* Texte et contenu */}
          <div className="flex flex-col flex-grow justify-between pr-0 lg:pr-12 text-center lg:text-left">
            <h1 className="text-2xl lg:text-3xl font-bold mb-4 text-[#0A827D]">
              {reference.title}
            </h1>
            <ul className="list-none text-base lg:text-lg text-gray-700 max-w-lg mx-auto lg:mx-0">
              {reference.details.map((detail, index) => (
                <li key={index} className="py-2">
                  {index === 0 ? detail : `${detailstitles[index]} : ${detail}`}
                </li>
              ))}
            </ul>

            {/* Boutons */}
          </div>
        </div>
      </div>
      <div className="pt-4 flex flex-wrap justify-center lg:justify-center gap-4">
        <Link to={`/references/`}>
          <button className="bg-[#0A827D] hover:bg-[#05736e] text-white font-bold py-3 px-5 shadow-lg transition-transform duration-300 hover:scale-110">
            Retour aux projets
          </button>
        </Link>
      </div>

      {/* Flèches de navigation */}
      <Link
        to={`/reference/${references[prevIndex].id}`}
        className="absolute hidden lg:flex left-5 top-1/2 transform -translate-y-1/2 bg-gray-200 p-2 rounded-full shadow-lg"
      >
        <FiChevronLeft className="w-6 h-6" />
      </Link>
      <Link
        to={`/reference/${references[nextIndex].id}`}
        className="absolute hidden lg:flex right-5 top-1/2 transform -translate-y-1/2 bg-gray-200 p-2 rounded-full shadow-lg"
      >
        <FiChevronRight className="w-6 h-6" />
      </Link>
    </div>
  );
};

export default ReferenceDetailPage;
